import { Box, Typography } from '@mui/material';
import type { FieldError } from 'react-hook-form';
import type { FormErrorBoxProps } from './types';

export default function FormErrorBox({ errors, sx }: FormErrorBoxProps) {
	const errorsWithMessage = errors.filter(
		(fieldError): fieldError is Partial<FieldError> & { message: string } =>
			!!fieldError?.message,
	);

	return (
		<Box sx={{ ...sx, padding: '5px 15px' }}>
			{errorsWithMessage.map((fieldError, errorIndex) => (
				<Typography key={errorIndex} color="error" variant="body2">
					{fieldError.message}
				</Typography>
			))}
		</Box>
	);
}
